import { Alert, Loader, Text } from "@mantine/core"
import { SuspenseWithErrorBoundary } from "../../-components/suspense"
import { useTranslations } from "../../utils/use-t"
import { DepartmentDutyRosterSpreadsheet } from "../../routes/app/-components/DutyScheduling/duty-roster-spreadsheet"
import { useGridStoreInitializer } from "../../routes/app/-components/DutyScheduling/state"
import { DutySchedulingContainer } from "../../routes/app/duties/-components/-DutySchedulingContainer"
import {
  useGetForExistingLeaveRequestSuspense,
  useGetForNewLeaveRequest,
} from "@/orval/gen"

export function DutyRosterForNewLeaveRequest({
  from,
  until,
}: {
  from: string
  until: string
}) {
  const { data, dataUpdatedAt, isLoading } = useGetForNewLeaveRequest({
    from,
    until,
  })

  const {
    appServer: { t },
  } = useTranslations()

  const { storeInitialized } = useGridStoreInitializer({
    data: data?.data ?? undefined,
    compact: true,
    updatedAt: dataUpdatedAt,
  })

  if (isLoading) {
    return <Loader />
  }

  if (!data) {
    return (
      <Alert title={t("Warning")} color="yellow">
        {t("MyAbsences_NewLeaveRequest_TimeAccountBalanceInPeriod_NotFound")}
      </Alert>
    )
  }

  return !data.allowed || !storeInitialized ? null : (
    <DutySchedulingContainer mah={400}>
      <SuspenseWithErrorBoundary>
        <DepartmentDutyRosterSpreadsheet
          focus="absence-planning"
          hoverEffect={false}
          title={<Text p={4}>{t("DutyRoster")}</Text>}
          data={data.data!}
          departmentTreeNodes={[]}
        />
      </SuspenseWithErrorBoundary>
    </DutySchedulingContainer>
  )
}

export function DutyRosterForExistingLeaveRequest({
  leaveRequestId,
}: {
  leaveRequestId: number
}) {
  const {
    appServer: { t },
  } = useTranslations()
  const { data, dataUpdatedAt } = useGetForExistingLeaveRequestSuspense({
    leaveRequestId,
  })

  const { storeInitialized } = useGridStoreInitializer({
    data: data.data ?? undefined,
    compact: true,
    updatedAt: dataUpdatedAt,
  })
  return data.allowed || storeInitialized ? (
    <DutySchedulingContainer mah={400}>
      <SuspenseWithErrorBoundary>
        <DepartmentDutyRosterSpreadsheet
          focus="absence-planning"
          hoverEffect={false}
          title={<Text>{t("DutyRoster")}</Text>}
          data={data.data!}
          departmentTreeNodes={[]}
        />
      </SuspenseWithErrorBoundary>
    </DutySchedulingContainer>
  ) : null
}
